import { useState, useMemo, useCallback } from "react";

interface OptionProps {
  defaultOption?: string;
  onChange?: (option: string, index: number) => void;
}

export function useOptions(options: string[], { defaultOption, onChange }: OptionProps) {
  const [currentIndex, setCurrentIndex] = useState(() => {
    const index = options.findIndex(option => option === defaultOption);
    return index >= 0 ? index : 0;
  });

  const currentOption = useMemo(() => options[currentIndex], [currentIndex, options]);

  const setCurrentOptionByIndex = useCallback(
    (index: number) => {
      if (index > options.length - 1) {
        setCurrentIndex(0);
        onChange?.(options[0], 0);
      } else if (index < 0) {
        const lastIndex = options.length - 1;

        setCurrentIndex(lastIndex);
        onChange?.(options[lastIndex], lastIndex);
      } else {
        setCurrentIndex(index);
        onChange?.(options[index], index);
      }
    },
    [options, onChange]
  );

  return { currentIndex, currentOption, setCurrentOptionByIndex };
}
